/* Is the next route point late, and by how much (issue #35).
 *
 * Its own module rather than two more exports from `PointTimeline`, which is the
 * file that draws the chain: a component file that also exports functions is a
 * file fast refresh gives up on — the rule `routeChain.ts` in this folder
 * follows too.
 *
 * ONE definition, because two surfaces ask the same question about the same
 * timestamp: the chain tints the current point's caption when the transition
 * out of it has run over, and the page raises the strip that offers «Груз в …».
 * Two comparisons is one screen that can contradict itself — an amber date with
 * no banner explaining it, or a banner over a date that reads as on time.
 *
 * `nextPointDueAt` itself is SERVED (AD-9): the server adds the current point's
 * arrival to the next transition's normative days. Nothing here recomputes it —
 * this only asks whether that instant has passed.
 */

/** Whether the served due date is in the past. Absent means nothing is due, so
 *  nothing can be late — no current point, no next one, or no norm on the
 *  transition between them. */
export function overdue(dueAt: string | undefined, now?: Date): boolean {
  if (dueAt === undefined) return false
  const due = Date.parse(dueAt)
  // A timestamp this side cannot parse is not an overdue transition: it is a
  // response nobody should be raising a banner from.
  if (Number.isNaN(due)) return false
  return due < (now ?? new Date()).getTime()
}

/** Whole days late, never below 1.
 *
 *  The banner names a NUMBER of days, and «просрочен на 0 дней» is not a
 *  sentence: anything past the due instant is a first day late, which is how
 *  the desk counts it on the phone. */
export function overdueDays(dueAt: string | undefined, now?: Date): number {
  if (dueAt === undefined || !overdue(dueAt, now)) return 0
  const elapsed = (now ?? new Date()).getTime() - Date.parse(dueAt)
  return Math.max(1, Math.floor(elapsed / 86_400_000))
}
